module.exports = __webpack_public_path__ + "img/filter_drama.b5c82ace.svg";